<template>
  <el-dialog
    :visible.sync="visible"
    title="退款记录"
    class="dialog"
    :close-on-click-modal="false"
  >
    <el-descriptions :column="2" size="medium">
      <el-descriptions-item label="入账金额（元）">
        {{ info.paidAmount }}
      </el-descriptions-item>
      <el-descriptions-item label="入账时间">
        {{ info.entryTime }}
      </el-descriptions-item>
      <el-descriptions-item label="退款到打款账号">
        {{ info.subAccountNo }}
      </el-descriptions-item>
      <el-descriptions-item label="户名">
        {{ info.draweeAccNo }}
      </el-descriptions-item>
    </el-descriptions>
    <jczh-table-content :data="info.refund" :option="listOption" border />
    <template v-slot:footer>
      <el-button type="primary" @click="closeDialog">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { guaranteePreSaveRefundStatusDict } from '@/dictionary/financial'

/**
 * 保证金预存退款明细
 */
export default {
  name: 'GuaranteePreSaveRefundDetailDialog',

  data() {
    return {
      visible: false,

      info: {},
      list: [],
      listOption: [
        { label: '退款金额（元）', prop: 'refundAmount' },
        { label: '余额（元）', prop: 'refundRemainAmount' },
        { label: '退款时间', prop: 'refundTime' },
        {
          label: '退款状态',
          prop: 'status',
          filter: value =>
            guaranteePreSaveRefundStatusDict.translate(value)?.label
        }
      ]
    }
  },

  methods: {
    openDialog(info) {
      this.visible = true
      this.$store
        .dispatch('finance/getGuaranteePreSaveRefundDetail', { id: info.id })
        .then(data => {
          this.info = Object.assign({}, this.form, data)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    closeDialog() {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
